import React, { useState } from 'react';
import {pdfStyles} from '../styles';
import { Text, View} from "@react-pdf/renderer";

const SecondTable = ({ tableData, gradebook, countOfPage }) => {
    // расчет правильного кол-ва стр в содержании
    // tableData.push({number: ' ', text: 'Раздел 22. Научная (научно-) деятельность ', page: '7'}) // проверка
    const arr = tableData.map(el => 
    {
        // ....... точки для содержания = через css  не смог
        //  перевожу строку в px и затем получаю колво символов в строке до края страницы
        const widthTextField = 310 // общая длинна строки на странице
        const textWidth = (getTextWidth(el.text, "12px Times-New-Roman") ) //сколько занимает места строка с текстом
        const textWidth2 = (getTextWidth('.', "12px Times-New-Roman") ) // сколько занимает места "."
        const textW = Math.round((widthTextField - +textWidth) / textWidth2 ) // доп кол-во символов к длинне строки
        const w = textW + el.text.length  // общая длинна строки с учетом точек
        const r = el.page === 'Стр.' ? el :  ({...el, text: (el.text.padEnd(w, " . "))}) // добавление в TEXT 
        return r
    })

    const numPage = () => {
        const newPage = 4 + countOfPage -1;
        arr[3].page = `4-${newPage}`;
        arr[4].page = `${newPage +1}`;
        arr[5].page = `${newPage +1}`;
        arr[6].page = `${newPage +2}`;
        return [...arr] 
    } 

    function getTextWidth(text, font) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    }
    

    return (
            <View style={[pdfStyles.table, pdfStyles.width70]}>
      
                {
                    numPage().map( (item, i) => (
                 
                        <View style={[pdfStyles.tableRow, pdfStyles.mb3]}>
                            <View style={pdfStyles.tableCol3}>
                                <Text>{ item.number }</Text>
                            </View>
                            <View style={pdfStyles.tableCol90} >
                                {/* <Text>{item.text}</Text> */}
                                <Text style={{  overflow: 'hidden', height: '20px', wordBreak: 'break-all'}}>{item.text}</Text>
                            </View>
                            <View style={pdfStyles.tableCol10}>
                                {i === 0 ?
                                <Text style={ pdfStyles.bold}> { item.page }</Text>
                               :  <Text>{ item.page }</Text>
                            } 
                            </View>
                        </View>
                    ))
                }
            </View>
    );
};

export default SecondTable;